module.exports = __webpack_public_path__ + "img/Liberty.0ba7cbb4.png";